export const IS_EMBED_LINK = !!window.location.href.match(
  /embedvph|metabox-configurator|metabox-viewer/gi,
);
